import $ from 'cash-dom'
import loadingAttributePolyfill from 'loading-attribute-polyfill/dist/loading-attribute-polyfill.js'

export default class ArchiveLoadMore {
  constructor({ $container }) {
    this.$container = $container

    this.ajaxQueryUrl = '/wp-admin/admin-ajax.php'

    this.buttonLoadingLabel = 'Loading...'

    this.constructElements()

    this.constructEvents()
  }

  static init() {
    const $containers = $(ArchiveLoadMore.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new ArchiveLoadMore({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$loadMoreButton = this.$container.find(ArchiveLoadMore.selectors.loadMoreButton)
    this.$loadMoreGrid = this.$container.find(ArchiveLoadMore.selectors.loadMoreGrid)
    this.$loadMoreStats = this.$container.find(ArchiveLoadMore.selectors.loadMoreStats)
    this.$loadMoreStatsNumber = this.$container.find(ArchiveLoadMore.selectors.loadMoreStatsNumber)
  }

  constructEvents() {
    this.$container
      .on('click', ArchiveLoadMore.selectors.loadMoreButton, (e) => this.doLoadMore({ e }))
  }

  getButtonLabel() {
    return this.$loadMoreButton.text()
  }

  getBlockId() {
    return this.$loadMoreGrid.attr('data-query-id')
  }

  getParams() {
    return ajax_query[this.blockId]
  }

  doChangeButtonLabel(label) {
    this.$loadMoreButton.text(label)
  }

  doChangeStatsNumber(number) {
    this.$loadMoreStatsNumber.text(number)
  }

  doButtonHide() {
    this.$loadMoreButton.remove()
  }

  doStatsHide() {
    this.$loadMoreStats.remove()
  }

  doAppendPosts({ data }) {
    this.$loadMoreGrid.append(data)

    $(ArchiveLoadMore.selectors.loadMoreGrid + ' noscript.loading-lazy').each(function(index, element) {
      loadingAttributePolyfill.prepareElement(element);
    })
  }

  doLoadMore() {
    this.buttonLabel = this.getButtonLabel()
    this.blockId = this.getBlockId()
    this.params = this.getParams()

    this.doFetch()
  }

  doFetch = async () => {
    this.doChangeButtonLabel(this.buttonLoadingLabel)

    await fetch(this.ajaxQueryUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams(this.params)
    })
    .then(response => response.text())
    .then(data => {
      this.doAppendPosts({ data })

      this.doChangeButtonLabel(this.buttonLabel)

      this.params['current_page']++
    })
    .catch((error) => {
      this.doButtonHide()
      console.error('Error:', error)
    })

    if (this.params['current_page'] == this.params['max_page']) {
      this.doButtonHide()
      this.doStatsHide()
    }
    else {
      this.doChangeStatsNumber(this.params['current_page'] * this.params['posts_per_page'])
    }
  }
}

ArchiveLoadMore.selectors = {
  container: '.js-archive-load-more',
  loadMoreGrid: '.js-archive-load-more-grid',
  loadMoreButton: '.js-archive-load-more-button',
  loadMoreStats: '.js-archive-load-more-stats',
  loadMoreStatsNumber: '.js-archive-load-more-stats-number',
}

ArchiveLoadMore.classes = {
  
}
